var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstallsafari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009FDA",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 3.31689 2.93156L 3.5542 3.18461C 3.61206 3.24503 3.70459 3.24638 3.76099 3.18778L 5.66675 1.25846L 5.66675 10.7066L 6.29663 10.7066L 6.29663 1.1768L 8.34473 3.22526C 8.40063 3.28288 8.49219 3.28166 8.5498 3.22184L 8.81006 2.97282C 8.86768 2.91325 8.8689 2.81791 8.81299 2.75993L 6.44116 0.388101C 6.43677 0.355874 6.42236 0.324502 6.39819 0.299356L 6.16089 0.046304C 6.13428 0.0187161 6.10059 0.0034573 6.06665 0.000527608C 6.02588 -0.00301243 5.98462 0.0112698 5.9541 0.0431301L 3.31348 2.71647C 3.25708 2.77506 3.25879 2.87138 3.31689 2.93156ZM 0.629639 16.0584L 0.629639 5.35465L 4.40747 5.35465L 4.40747 4.72501L 0 4.72501L 0 16.688L 11.9629 16.688L 11.9629 4.72501L 7.55566 4.72501L 7.55566 5.35465L 11.3333 5.35465L 11.3333 16.0584L 0.629639 16.0584Z",
    transform: "translate(0.518555 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstallsafari);
export default __webpack_public_path__ + "static/media/icon-installsafari.87605d8caabcd91aca3cd8ce98400881.svg";
export { ForwardRef as ReactComponent };